// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chart-bar.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/chart-bar'

import { Icon, type IconComponentProps } from '../icon'

export const ChartBarIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
